import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=f7f54b3c&scoped=true"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=f7f54b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f54b3c",
  null
  
)

export default component.exports